<div class="content-info">

  <!-- Transfer Out List Content -->
  <div *ngIf="activeTab === 'transfer_out'">
    <div class="content-title">
      <h3 class="title">Stock Transfer Out</h3>
      <div class="title-actions">
        <label class="zf-search" title="Search by transfer number">
          <i class="bi bi-search"></i>
          <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search transfer number" />
        </label>
        <button class="btn btnprimary text-nowrap" [routerLink]="['/transfer-out/create']">
          <i class="bi bi-plus-lg"></i>Create Transfer Out
        </button>
      </div>
    </div>

    <!-- Lifecycle sub-tabs -->
    <div class="zf-card-head">
      <div class="zf-tabs">
        <button type="button" class="zf-tab" [class.active]="outboundStatusTab === 'drafts'"
          (click)="setOutboundTab('drafts')">Drafts</button>
        <button type="button" class="zf-tab" [class.active]="outboundStatusTab === 'orders'"
          (click)="setOutboundTab('orders')">Orders</button>
        <button type="button" class="zf-tab" [class.active]="outboundStatusTab === 'in_transit'"
          (click)="setOutboundTab('in_transit')">In Transit</button>
        <button type="button" class="zf-tab" [class.active]="outboundStatusTab === 'completed'"
          (click)="setOutboundTab('completed')">Completed</button>
      </div>
      <div class="zf-tabs-right ms-auto">
        @if (outboundStatusTab === 'drafts') {
        Transfers you've started but not yet sent. Edit and dispatch when ready.
        } @else if (outboundStatusTab === 'orders') {
        Box-shipment orders. Each trip dispatch creates a separate shipment that carries the goods;
        <strong>&nbsp;Shipped&nbsp;</strong> means everything ordered has left the warehouse.
        } @else if (outboundStatusTab === 'in_transit') {
        Shipped transfers awaiting receipt at the destination.
        } @else {
        Received and closed transfers. Read-only.
        }
      </div>
    </div>

    <div class="common-table">
      <div class="table-responsive" style="max-height: 65vh; overflow-y: auto; overflow-x: auto;">
        <table class="table">
          <thead>
            <tr>
              <th>Transfer Number</th>
              <th>From Location</th>
              <th>To Location</th>
              @if (outboundStatusTab === 'orders') { <th>Shipments</th> }
              <th>Type</th>
              <th>Transfer Date</th>
              <th class="zf-num">Total Units</th>
              <th class="zf-num">Total Amount</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            @if(transferLoading) {
            <tr>
              <td [attr.colspan]="outboundStatusTab === 'orders' ? 10 : 9" class="text-center">Loading transfers…</td>
            </tr>
            } @else { @if(!transferList.length) {
            <tr>
              <td [attr.colspan]="outboundStatusTab === 'orders' ? 10 : 9">
                <div class="zf-empty">
                  <strong>No transfers in this view</strong>
                  <span>Try another tab or create a transfer out.</span>
                </div>
              </td>
            </tr>
            } @else { @for(transfer of transferList; track transfer.id) {
            <tr>
              <td class="zf-key">
                <a [routerLink]="['/transfer-out/edit', transfer.id]" [queryParams]="{ view: true }">
                  {{ transfer.transferOutNumber }}
                </a>
                @if (transfer.parentTransferOut) {
                <div class="text-muted" style="font-size: 10.5px; font-family: var(--zf-font);">
                  from {{ transfer.parentTransferOut.transferOutNumber }}
                </div>
                }
              </td>
              <td>{{ transfer.sourceLocation?.name || "-" }}</td>
              <td>{{ transfer.targetLocation?.name || "-" }}</td>
              @if (outboundStatusTab === 'orders') {
              <td>
                @if (transfer.shipments?.length) {
                @for (s of transfer.shipments; track s.id) {
                <a class="d-block zf-mono" [routerLink]="['/transfer-out/edit', s.id]" [queryParams]="{ view: true }"
                  [title]="s.status">{{ s.transferOutNumber }}</a>
                }
                } @else {
                <span class="text-muted">Not shipped yet</span>
                }
              </td>
              }
              <td class="zf-dim">{{ transfer.type || "-" }}</td>
              <td class="zf-mono">{{ transfer.createdAt | date : "dd-MM-yy" }}</td>
              <td class="zf-num">{{ transfer.totalQty || 0 }}</td>
              <td class="zf-num zf-strong">
                {{ transfer.totalAmount || 0 | number : '1.2-2' }}
                <!-- E-way bill state, from the same valuation the bill uses
                     (consignment value incl. GST vs the client threshold). -->
                @if (transfer.ewayBillMissing) {
                <a class="zf-status danger text-decoration-none d-inline-flex mt-1" routerLink="/transfer-out/eway-bill/create"
                  [title]="'Consignment value ₹' + (transfer.consignmentValue | number:'1.0-0') + ' is above the e-way bill threshold and no bill has been generated'">
                  <i class="bi bi-exclamation-triangle"></i> E-way bill required
                </a>
                } @else if (transfer.ewayBill?.status === 'GENERATED') {
                <span class="zf-status ok d-inline-flex mt-1"
                  [title]="'E-way bill ' + transfer.ewayBill.ewayBillNo + (transfer.ewayBill.validUpto ? ', valid up to ' + transfer.ewayBill.validUpto : '')">
                  <i class="bi bi-truck"></i> EWB {{ transfer.ewayBill.ewayBillNo }}
                </span>
                }
              </td>
              <td>
                @if (transfer.status === 'DRAFT') {
                <span class="zf-status"><i class="bi bi-pencil-square"></i> Draft</span>
                } @else if (transfer.status === 'IN_TRANSIT') {
                <span class="zf-status warn"><i class="bi bi-truck"></i> In Transit</span>
                } @else if (transfer.status === 'POSTED') {
                <span class="zf-status ok"><i class="bi bi-check2-circle"></i> Completed</span>
                } @else if (transfer.status === 'CANCELLED') {
                <span class="zf-status text-decoration-line-through">Cancelled</span>
                } @else if (transfer.status === 'ORDERED') {
                <span class="zf-status info"><i class="bi bi-clipboard-check"></i> Ordered</span>
                } @else if (transfer.status === 'PARTIALLY_SHIPPED') {
                <span class="zf-status warn"><i class="bi bi-box-seam"></i> Partially Shipped</span>
                } @else if (transfer.status === 'SHIPPED') {
                <span class="zf-status primary"><i class="bi bi-truck"></i> Shipped</span>
                } @else if (transfer.status === 'CLOSED') {
                <span class="zf-status"><i class="bi bi-slash-circle"></i> Closed</span>
                } @else {
                <span class="zf-status">{{ transfer.status }}</span>
                }
              </td>
              <td>
                <div class="td-actions-btn">
                  @if (transfer.status === 'DRAFT') {
                  <button class="btn btn-edit" [routerLink]="['/transfer-out/edit', transfer.id]" title="Edit draft">
                    <i class="bi bi-pencil-square"></i>
                  </button>
                  } @else {
                  <button class="btn btn-edit" [routerLink]="['/transfer-out/edit', transfer.id]"
                    [queryParams]="{ view: true }" title="View">
                    <i class="bi bi-eye"></i>
                  </button>
                  }
                  <button class="btn btn-download" (click)="downloadTransferOut(transfer.id)" title="Download PDF">
                    <i class="bi bi-file-earmark-pdf"></i>
                  </button>
                </div>
              </td>
            </tr>
            } } }
          </tbody>
        </table>
      </div>

      <app-pagination [page]="currentPage" [limit]="pageSize" [pageCount]="pageCount" (pageChange)="goToPage($event)"
        (limitChange)="onPageSizeChange($event)">
      </app-pagination>
    </div>
  </div>

  <!-- E-Way Bill List Content -->
  <div *ngIf="activeTab === 'eway_bill'">
    <div class="content-title">
      <h3 class="title">E-Way Bills</h3>
      <div class="title-actions">
        <button class="btn btnprimary text-nowrap" [routerLink]="['/transfer-out/eway-bill/create']">
          <i class="bi bi-plus-lg"></i>Create E-Way Bill
        </button>
      </div>
    </div>

    <div class="common-table mt-2">
      <div class="table-responsive" style="max-height: 65vh; overflow-y: auto; overflow-x: auto;">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">E-Way Bill No</th>
              <th scope="col">Date</th>
              <th scope="col">Supply Type</th>
              <th scope="col">Doc No</th>
              <th scope="col">Transporter</th>
              <th scope="col" class="zf-num">Value</th>
              <th scope="col">Consolidated</th>
              <th scope="col">Status</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            @if(ewayLoading) {
            <tr>
              <td colspan="9" class="text-center">Loading e-way bills…</td>
            </tr>
            } @else { @if(!ewayBillList.length) {
            <tr>
              <td colspan="9">
                <div class="zf-empty">
                  <strong>No e-way bills yet</strong>
                  <span>Bills are generated for transfers above the e-way bill threshold.</span>
                </div>
              </td>
            </tr>
            } @else { @for(bill of ewayBillList; track bill.id || $index) {
            <tr>
              <td class="zf-key">{{ bill.ewayBillNo || '-' }}</td>
              <td class="zf-mono">{{ (bill.ewayBillDate | date : "dd-MM-yy") || '-' }}</td>
              <td class="zf-dim">{{ bill.supplyType || '-' }}</td>
              <td class="zf-mono zf-dim">{{ bill.docNo || '-' }}</td>
              <td>{{ bill.transporterName || '-' }}</td>
              <td class="zf-num zf-strong">
                {{ (bill.consignmentValue ?? bill.totalValue) | number:'1.2-2' }}
                @if (bill.required === false) {
                <small class="d-block text-muted" style="font-family: var(--zf-font)">voluntary</small>
                }
              </td>
              <td class="zf-mono zf-dim">
                @if (bill.consolidation?.cewbNo) {
                <span [title]="'Vehicle ' + (bill.consolidation.vehicleNo || '')">{{ bill.consolidation.cewbNo }}</span>
                } @else { - }
              </td>
              <td>
                <span class="zf-status" [ngClass]="{
                  ok: bill.status === 'GENERATED',
                  danger: bill.status === 'FAILED' || bill.status === 'CANCELLED',
                  info: bill.status === 'PENDING' || !bill.status
                }">{{ bill.status || 'GENERATED' }}</span>
              </td>
              <td class="text-center">
                <div ngbDropdown class="d-inline-block" container="body">
                  <button class="btn zf-row-menu" type="button" ngbDropdownToggle title="Actions">
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>
                  <div ngbDropdownMenu class="dropdown-menu-end">
                    <button ngbDropdownItem (click)="openUpdateModal(bill)">
                      <i class="bi bi-truck"></i> Update Part-B
                    </button>
                    <button ngbDropdownItem class="text-danger" (click)="openCancelModal(bill)"
                      [disabled]="bill.status !== 'GENERATED'">
                      <i class="bi bi-x-octagon"></i> Cancel e-way bill
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            } } }
          </tbody>
        </table>
      </div>

      <app-pagination [page]="ewayCurrentPage" [limit]="ewayPageSize" [pageCount]="ewayPageCount"
        (pageChange)="goToPage($event)" (limitChange)="onPageSizeChange($event)">
      </app-pagination>
    </div>
  </div>
</div>

<!-- Modals -->
<div class="modal-backdrop fade show" *ngIf="showCancelModal || showUpdateModal" (click)="closeModals()"></div>

<!-- Cancel Modal -->
<div class="modal fade show d-block" tabindex="-1" *ngIf="showCancelModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Cancel e-way bill</h5>
        <button type="button" class="btn-close" (click)="closeModals()"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label class="form-label">Cancel reason code</label>
          <select class="form-select" [(ngModel)]="cancelData.cancelRsnCode">
            <option *ngFor="let opt of cancelReasonOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </div>
        <div class="mb-1">
          <label class="form-label">Remark</label>
          <input type="text" class="form-control" [(ngModel)]="cancelData.cancelRmrk" placeholder="Reason for cancellation">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btnsecondary" (click)="closeModals()">Close</button>
        <button type="button" class="btn btn-danger" (click)="submitCancel()">Cancel bill</button>
      </div>
    </div>
  </div>
</div>

<!-- Update Part-B Modal -->
<div class="modal fade show d-block" tabindex="-1" *ngIf="showUpdateModal">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Update Part-B</h5>
        <button type="button" class="btn-close" (click)="closeModals()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="form-label">From place</label>
            <input type="text" class="form-control" [(ngModel)]="updateData.fromPlace">
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">From state (code)</label>
            <input type="number" class="form-control" [(ngModel)]="updateData.fromState">
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Reason code</label>
            <select class="form-select" [(ngModel)]="updateData.reasonCode">
              <option *ngFor="let opt of updateReasonOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Reason remark</label>
            <input type="text" class="form-control" [(ngModel)]="updateData.reasonRemark">
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Trans mode</label>
            <select class="form-select" [(ngModel)]="updateData.transMode">
              <option *ngFor="let opt of transModes" [value]="opt.value">{{ opt.label }}</option>
            </select>
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Vehicle no</label>
            <input type="text" class="form-control" [(ngModel)]="updateData.vehicleNo">
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Trans doc no</label>
            <input type="text" class="form-control" [(ngModel)]="updateData.transDocNo">
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Trans doc date</label>
            <input type="date" class="form-control" [(ngModel)]="updateData.transDocDate">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btnsecondary" (click)="closeModals()">Close</button>
        <button type="button" class="btn btnprimary" (click)="submitUpdate()">Update Part-B</button>
      </div>
    </div>
  </div>
</div>
